<template>
    <form class="contactform">
        <div class="server-errors" v-if="hasFatalError">
            <h3>Es ist ein unverwarteter Fehler aufgetreten</h3>
            <p>Bitte wenden sie sich an den Kundensupport.</p>
        </div>

        <div class="server-errors" v-if="hasErrors && !hasFatalError">
            <h3>Es sind Fehler aufgetreten</h3>
            <p>Folgende Fehler sind aufgetreten:</p>
            <p v-for="msg in viewData.Errors"><em class="error">-{{msg}}</em></p>
            <p>Bitte korrigieren Sie Ihre Eingaben und schicken Sie das Formular noch einmal ab.</p>
        </div>

        <div class="server-errors" v-if="model.berufsnachweisArt == 'Upload' && model.berufsnachweis == null && !hasFatalError">
            <h3>Laden sie einen Berufsnachweis hoch oder wählen sie eine andere Zustellung für Ihren Berufsnachweis</h3>
        </div>

        <div v-if="viewData.sent && !hasFatalError">
            <h3>Der Datensatz wurde geändert.</h3>
            <div class="form input-submit">
                <p><input type="submit" name="input-submit" id="input-submit" @click.prevent="reloadForm" value="Mein Profil bearbeiten"></p>
            </div>
        </div>

        <div v-if="!viewData.sent && !hasFatalError">
            <div class="input-group">
                <h3>Zugangsdaten</h3>
                <div class="form input-text-single">
                    <span class="input">
                        <input id="Benutzername" name="Benutzername" placeholder="Gewünschter Benutzername*" required :readonly="true" type="text" v-model="model.benutzername">
                    </span>
                </div>
                <div class="form input-text-double-1">
                    <input id="PasswortAlt" name="PasswortAlt" placeholder="Altes Passwort (nur bei Neueingabe)" type="password" v-model="model.passwortAlt">
                </div>
                <div class="form input-text-double-1">
                    <span class="input">
                        <input id="PasswortNeu" name="PasswortNeu" placeholder="Neues Passwort" type="password" v-model="model.passwortNeu">
                    </span>
                    <span class="password-strength-container topmargin">
                        <span class="password-strength"></span>
                    </span>
                </div>
                <div class="form input-text-double-1">
                    <span class="input">
                        <input id="PasswortNeuWiederholung" name="PasswortNeuWiederholung" placeholder="Neues Passwort wiederholen" type="password" v-model="model.passwortNeuWiederholung">
                    </span>
                    <span class="input">
                    </span>
                </div>
            </div>
            <div class="input-group">
                <h3>Persönliche Angaben</h3>
                <!-- Input zweispaltig 1 -->
                <div class="form input-text-double-1">
                    <span class="input">
                        <span class="select-style">
                            <select name="Anrede" id="Anrede" v-model="model.anrede">
                                <option value="" disabled>Anrede</option>
                                <option v-for="s in anreden" :value="s">{{s}}</option>
                            </select>
                        </span>
                    </span>
                    <span class="input">
                        <span class="select-style">
                            <select id="Titel" name="Titel" v-model="model.titel">
                                <option value="" disabled>Titel</option>
                                <option v-for="s in titel" :value="s">{{s}}</option>
                            </select>
                        </span>
                    </span>
                </div>
                <div class="form input-text-double-1">
                    <span class="input">
                        <input id="Vorname" name="Vorname" placeholder="Vorname*" type="text" v-model="model.vorname" required>
                    </span>
                    <span class="input">
                        <input id="Nachname" name="Nachname" placeholder="Nachname*" type="text" v-model="model.nachname" required>
                    </span>
                </div>
            </div>
            <div class="input-group">
                <h3>Berufliche Angaben</h3>
                <!-- Arzt -->
                <div v-if="model.rollen && model.berufsbezeichnung == model.rollen.Arzt.name" class="form input-text-double-1">
                    <span class="input">
                        <input id="Berufsnummer" name="Berufsnummer" placeholder="Ärzte-Nr./IDF/BTM-Nr.(7-stellig)" type="text" v-model="model.berufsnummer">
                    </span>
                    <span class="input">
                        <input id="Facharztgruppe" name="Facharztgruppe" placeholder="Facharztgruppe" type="text" v-model="model.facharztgruppe">
                    </span>
                </div>
                <!-- ApothekerInhaber -->
                <div v-if="model.rollen &&  model.berufsbezeichnung == model.rollen.ApothekerInhaber.name" class="form input-text-single">
                    <span class="input">
                        <input id="Berufsnummer" name="Berufsnummer" placeholder="Ärzte-Nr./IDF/BTM-Nr.(7-stellig)" type="text" v-model="model.berufsnummer">
                    </span>
                </div>
                <!-- Sonstige: hier ist die Berufsbezeichnung im model und wird unverändert zurückgespielt -->
                <div class="form input-text-single">
                    <span class="input">
                        <input id="Institution" name="Institution" placeholder="Institutionsname/Apothekenname/Praxis" type="text" v-model="model.institution">
                    </span>
                </div>
                <div class="form input-text-single">
                    <span class="input">
                        <input id="KundenNummer" name="KundenNummer" placeholder="Ihre ALIUD-Kundennummer" type="text" v-model="model.kundenNummer">
                    </span>
                </div>
                <upload-berufsnachweis :model="model"></upload-berufsnachweis>
            </div>
            <div class="input-group">
                <h3>Berufliche Kontaktdaten</h3>
                <div class="form input-text-single">
                    <span class="input">
                        <input id="Strasse" name="Strasse" placeholder="Straße*" type="text" v-model="model.strasse" required>
                    </span>
                </div>
                <div class="form input-text-triple-1">
                    <span class="input">
                        <input id="Land" name="Land" placeholder="Land" :readonly="true" type="text" v-model="model.land">
                    </span>
                    <span class="input">
                        <input id="Plz" name="Plz" placeholder="PLZ*" type="text" v-model="model.plz" required>
                    </span>
                    <span class="input">
                        <input id="Ort" name="Ort" placeholder="Ort*" type="text" v-model="model.ort" required>
                    </span>
                </div>
                <div class="form input-text-single">
                    <email-editor :model="model"></email-editor>
                </div>
                <div class="form input-text-double-1">
                    <span class="input">
                        <input id="Telefon" name="Telefon" placeholder="Telefon" type="text" v-model="model.telefon">
                    </span>
                    <span class="input">
                        <input id="Fax" name="Fax" placeholder="Fax" type="text" v-model="model.fax">
                    </span>
                </div>
            </div>
            <div class="input-group">
                <h3>Newsletter</h3>
                <div class="form input-checkbox">
                    <p>Bitte senden Sie mir regelmäßig folgende Newsletter:</p>
                </div>
                <newsletter-abos :model="model"></newsletter-abos>
                <div class="textonly">
                    <hr>
                </div>
                <div class="textonly">
                    <h3>AGB und Datenschutzbestimmung:</h3>
                </div>
                <div class="input-group">
                    <div class="form input-checkbox">
                        <p>
                            <input class="check-box" id="NewsletterAkzeptieren" name="NewsletterAkzeptieren" type="checkbox" v-model="model.NewsletterAkzeptieren">
                            Ja, ich habe die <a href="https://www.aliud.de/metaseiten/datenschutz" target="_blank"> Informationen zum Datenschutz, </a> <a href="#" class="popover privacy"> Hinweise zur Datenverwendung</a> und die<br> <a href="https://www.aliud.de/metaseiten/agb" target="_blank"> Allgemeinen Geschäftsbedingungen</a> gelesen und bin damit einverstanden.*
                        </p>
                    </div>
                </div>
            </div>
            <div class="textonly">
                <hr>
            </div>
            <div class="textonly legend">
                <p>*Pflichtfelder</p>
            </div>
            <div class="form input-submit">
                <p><input type="submit" name="input-submit" id="input-submit" @click.prevent="onSubmit" value="Abschicken"></p>
            </div>
            <div class="popoverContent privacy">
                <h3>Hinweise zur Datenverwendung: </h3>
                <p>
                    Ich willige gegenüber der ALIUD PHARMA in die Verwendung meiner oben aufgeführten E-Mail-Adresse zur Zusendung von Newslettern ein. Eine Abmeldung ist jederzeit möglich. Datennutzung und -speicherung: Wir machen Sie darauf aufmerksam, dass ALIUD PHARMA Ihre Daten ausschließlich im Rahmen der gesetzlichen Bestimmungen zur Übersendung von Newslettern verwenden wird und diese hierzu auch an externe Dienstleister weitergeben kann. Für den Fall, dass Sie weitere Informationen zum Umgang mit Ihren Daten erfahren und/oder zukünftig keine Informationen zu unseren Produkten oder Veranstaltungen mehr erhalten möchten, können Sie uns dies ohne Angabe von Gründen über unten genannte Kontaktdaten mitteilen.
                </p>
            </div>
        </div>
    </form>

</template>


<script lang="ts">
    import { defineComponent } from "vue";
    import axios, { AxiosError } from "axios";
    import { extractAttrs } from "../../services/extract-attrs";
    import UploadBerufsnachweis from "./UploadBerufsnachweis.vue";
    import EmailEditor from "./EmailEditor.vue";
    import NewsletterAbos from "./NewsletterAbos.vue";

    const MeinProfilBearbeitenForm = defineComponent({
        name: "MeinProfilBearbeitenForm",
        data() {
            return {
                viewData: Object as any,
                model: Object as any,
                sessionId: "",
                anreden: ["Frau", "Herr"],
                titel: ["Dr.", "Prof.", "Prof. Dr."],
                hasErrors: false,
                hasFatalError: false,
                errors: [] as string[]
            }
        },
        props: {
            container: HTMLDivElement
        },
        beforeMount() {
            const attrs = extractAttrs(this.container!);
            const session: string = attrs["session"];
            const userGuid: string = attrs["user"];
            const url="/umbraco/login/meinprofilbearbeitenform/getmodel?user=" + userGuid + "&sessionstr=" + session

            axios.get(url).then((response: any)=>{
                this.model = response.data;
                this.model.anrede = this.model.anrede ?? "";
                this.model.titel = this.model.titel ?? "";
                this.model.berufsbezeichnung = this.model.berufsbezeichnung ?? "";

                this.sessionId = response["sessionId"];

            }).catch((reason: AxiosError)=> {
                this.hasFatalError=true;
            });
        },
        methods: {
            onSubmit() {
                let model = this.model as any;
                model.SessionId = this.sessionId;

                axios.post("/umbraco/login/meinprofilbearbeitenform/abschicken", model).then((response) =>{
                    this.viewData = response.data;
                    this.sessionId = response.data.SessionId;
                    console.log("vieData: ", this.viewData);

                    if (this.viewData.Errors && this.viewData.Errors.length > 0) {
                    this.hasErrors=true;
                    window.scrollTo({
                            top: 0,
                            behavior: 'smooth' // Für sanftes Scrollen
                        });
                    }
                })
                .catch((reason: AxiosError)=>{
                    const data : any = reason.response?.data;
                    const errors : registrierungErrors = data.errors;
                    const serverSideErrors = [] as string[];
                    for (const key in errors) {
                        if(errors.hasOwnProperty(key)){
                            const errorArray = errors[key as keyof typeof errors] as string[];
                            for(let i= 0; i < errorArray.length; i++) {
                                serverSideErrors.push(errorArray[i]);
                            }
                        }
                    }

                    this.hasErrors=true;
                    this.errors=[...serverSideErrors];

                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth' // Für sanftes Scrollen
                    });
                });
            },
            reloadForm() {
                this.viewData.sent = false;
                window.location.reload();
            }
        },
        components: {
            UploadBerufsnachweis,
            EmailEditor,
            NewsletterAbos
        }
    });
    export default MeinProfilBearbeitenForm;

    interface registrierungErrors {
        Passwort? : string[],
        Benutzername? : string[],
        PasswortWiederholung? : string[],
        Anrede? : string[],
        Vorname? : string[],
        Nachname? : string[],
        Berufsbezeichnung?: string[],
        Institution?: string[],
        BerufsnachweisArt?: string[],
        Strasse?: string[],
        Plz?: string[],
        Ort?: string[],
        EMail?: string[],    
    }
</script>
